import React from 'react';
import Lottie from 'react-lottie';
import './Brown_Success_Lottie.css';
import * as animationData from './Brown_Success_Lottie.json';

function Brown_Success_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Brown_Success_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default Brown_Success_Lottie;